/**
 * 地图相关状态管理
 * 从 manhattan-baldr-webapp/store/map.ts 搬运并适配为 REPO A 的 defineStore
 */
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

const mapStore = defineStore({
  state: () => ({
    mapInfo: {} as Record<string, any>,
    /**
     * 展示ocr确认弹窗
     */
    showPopup: false,
    /**
     * 展示地图搜索页
     */
    showSearch: false,
    /**
     * 展示地图定点页
     */
    showMap: false,
    /**
     * 搜索框默认搜索值
     */
    defaultSearchVal: null as string | null,
    /**
     * 地址类型
     */
    addressStatus: 0,

    /**
     * 用户地址类型的 初始状态
     */
    initiateState: 0,
    /**
     * 街道名称 用于弹窗回显
     */
    streetName: '',
    /**
     * Municipio，Ciudad，Estado
     */
    addressDetail: '',
    /**
     * ocr地址
     */
    ocrAddressInfo: {
      postCode: '', // 数据提交、回显时使用
      postCodeId: '',
      streetName: '', //数据提交
      addressRemark: '',
      address: '',
      lat: '',
      lng: '',
    },

    addressMap: {
      postCode: '',
      postCodeId: '',
      streetName: '',
      addressRemark: '',
      address: '',
      lat: '',
      lng: '',
    },

    /**
     * 原始数据
     */
    originalAddress: {
      postCode: '',
      postCodeId: '',
      streetName: '',
      addressRemark: '',
      address: '',
      lat: '',
      lng: '',
    },

    /**
     * 地址确认提示强化 弹窗上显示的信息
     */
    strengtheningMsg: {
      colonia: '',
      municipioCiudadEstado: '',
    },

    /**
     * 搜索框内容
     */
    searchVal: '',
    /**
     * 是否选中ine
     */
    isCheckedINE: false,
    // 来源页面
    source: 0,

    // 新的地址确认页
    newConfirm: false,

    // 地址是否超长
    isExtraLong: false,

    // 用卡是否需要校验postCode
    verifyPostCode: false,

    // 从搜索页 返回时，是否只返回
    onlyBack: false,
  }),
  getters: {
    isShowPopup(state) {
      return state.showPopup
    },
    isShowSearch(state) {
      return state.showSearch
    },
    isShowMap(state) {
      return state.showMap
    },
  },
  mutations: {
    // 拉起地图搜索页，更新其默认检索词
    goSearch(state, val: string | null) {
      state.showSearch = true
      state.showPopup = false
      state.showMap = false
      state.defaultSearchVal = val
    },

    // 拉起地图定点页, 更新定点地址信息
    goMap(state) {
      state.showSearch = false
      state.showPopup = false
      state.showMap = true
    },

    // 展示ocr确认弹窗
    goPopup(state) {
      state.showSearch = false
      state.showPopup = true
      state.showMap = false
    },
    // 关闭搜索弹窗
    hideSearchPopup(state) {
      state.showSearch = false
      state.showMap = false
    },
    setAddressStatus(state, status: number) {
      state.addressStatus = status
    },
    saveInitialState(state, status: number) {
      state.initiateState = status
    },
    setStreetName(state, name: string) {
      state.streetName = name
    },
    setOcrAddressInfo(state, data: Record<string, any>) {
      Object.assign(state.ocrAddressInfo, data)
    },
    saveOriginalAddress(state, data: Record<string, any>) {
      Object.assign(state.originalAddress, data)
    },
    setAddressMap(state, data: Record<string, any>) {
      Object.assign(state.addressMap, data)
    },
    setAddressDetail(state, data: string) {
      state.addressDetail = data
    },
    setCheckedINE(state, data: boolean) {
      state.isCheckedINE = data
    },
    setSearchVal(state, data: string) {
      state.searchVal = data
    },

    setSource(state, data: number) {
      state.source = data
    },

    updateMapInfo(state, info: Record<string, any>) {
      if (state.mapInfo) {
        Object.assign(state.mapInfo, info)
      }
      state.mapInfo = Object.assign({}, info)
    },

    setNewConfirm(state, status: boolean) {
      state.newConfirm = status
    },

    setExtraLong(state, status: boolean) {
      state.isExtraLong = status
    },

    setVerifyPostCode(state, status: boolean) {
      state.verifyPostCode = status
    },
    closeShowPopup(state) {
      state.showPopup = false
    },
    saveStrengtheningMsg(
      state,
      data: {
        colonia?: string
        municipioCiudadEstado?: string
      }
    ) {
      state.strengtheningMsg = {
        colonia: data.colonia || '',
        municipioCiudadEstado:
          data.municipioCiudadEstado || '',
      }
    },

    setOnlyBack(state, data: boolean) {
      state.onlyBack = data
    },
  },
})

export default mapStore
export type IMapStoreState = IStoreState<
  typeof mapStore.state
>
